import { getEntityProfileTabUpdateOwner } from '../../../Entity'

export function toApplicantProfileUpdates({ items, t }) {
  return items.map(item => ({
    ...item,
    owner_obj: getEntityProfileTabUpdateOwner(item.actor),
    text: t(item.text),
    timestamp: item.at,
  }))
}
